import { booleanAttribute, Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sc-divider',
  standalone: true,
  imports: [],
  templateUrl: './divider.component.html',
  styleUrl: './divider.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { class: 'divider', '[class.divider--horizontal]': 'horizontal', '[class.divider--vertical]': '!horizontal' }
})
export class DividerComponent {
  horizontal = input(false, { transform: booleanAttribute });
}
